import { Map } from 'immutable';
import { createReducerBySpec } from '@Utils/Redux/reducerFactory';

import { exportTabActionsTypes, chemQuoteExportTabActionsTypes } from './ExportTabConstants';

export const initialState = Map({
  exportType: null,
  exportResult: null,
  retryDisabled: false,
  downloadUrl: null,
  tooltipModalOpened: false,
  cancelledJobIds: [],
});

const createReducer = (actions) => {
  const spec = {
    [actions.exportTabSetExportTypeReducerType]: (state, action) => {
      const { exportType } = action.payload;
      return state.set('exportType', exportType);
    },
    [actions.exportTabSetExportResultReducerType]: (state, action) => {
      const { exportResult } = action.payload;
      return state.set('exportResult', exportResult);
    },
    [actions.exportTabSetRetryDisabledReducerType]: (state, action) => {
      const { retryDisabled } = action.payload;
      return state.set('retryDisabled', retryDisabled);
    },
    [actions.exportTabSetTooltipModalOpenedReducerType]: (state, action) => {
      const { tooltipModalOpened } = action.payload;
      return state.set('tooltipModalOpened', tooltipModalOpened);
    },
    [actions.exportTabSetDownloadUrlReducerType]: (state, action) => {
      const { downloadUrl } = action.payload;
      return state.set('downloadUrl', downloadUrl);
    },
    [actions.exportTabSetCancelledJobIdsReducerType]: (state, action) => {
      const { cancelledJobIds } = action.payload;
      return state.set('cancelledJobIds', cancelledJobIds);
    },
  };
  return createReducerBySpec(spec, initialState);
};

export const exportTabReducer = createReducer(exportTabActionsTypes);
export const chemquoteExportReducer = createReducer(chemQuoteExportTabActionsTypes);
